import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const OPTS = [['REPAIRED', 'Repaired', 'Rejoins the order, goes on to Pressing', 'border-emerald-600 bg-emerald-600 text-white'],
  ['REJECTED', 'Rejected', 'Counted as a loss on the order', 'border-rose-600 bg-rose-600 text-white']];

/** Damage Section: a job-order piece is marked Repaired (rejoins the order) or Rejected (a loss on the order). */
export const PjoOutcomePick = ({ joId, value, onChange }) => (
  <div className="rounded-md border border-[#E5DFD0] bg-white p-3 space-y-2" data-testid="pjo-outcome">
    <p className="text-sm text-gray-700">Job order <b className="font-mono" data-testid="usn-pjo-id">{joId}</b> — mark this piece:</p>
    <div className="grid grid-cols-2 gap-2">
      {OPTS.map(([v, label, hint, on]) => (
        <button key={v} type="button" onClick={() => onChange(v)} data-testid={`pjo-outcome-${v.toLowerCase()}`} aria-pressed={value === v}
          className={`rounded-md border-2 px-3 py-2 text-left transition-colors ${value === v ? on : 'border-gray-200 text-gray-700 hover:bg-gray-50'}`}>
          <div className="flex items-center gap-1.5 text-sm font-semibold">{value === v && <CheckCircle2 className="w-4 h-4" />}{label}</div>
          <div className="text-[11px] opacity-80">{hint}</div>
        </button>
      ))}
    </div>
  </div>
);

export const pjoSplitText = (split) => (split || []).map((s) => `${s.jo_id} · ${s.pcs} pcs`).join(', ');
